<template>
    <div class="vcode-wrap">
        {{vCodeInfo.vCodeDesc}}
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'vCode',
  computed: {
    ...mapGetters('detailv3', ['vCodeInfo'])
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.vcode-wrap{
    background: url(~assets/img/product/detail/vcode.png) no-repeat center center;
    background-size: cover;
    color: #FFF;
    font-size: 36px;
    padding:42px 0 0 36px;
    line-height: 42px;
    height: 150px;
    margin-bottom: -108px;
    margin-top: 30px;
    border-radius: 39px;
    @media (prefers-color-scheme: dark) {
      background: url(~assets/img/product/detail/vcode-dark.png) no-repeat center center;
      background-size: cover;
    }
}
</style>